import { jsx } from "react/jsx-runtime";
import { useForkRef } from "@mui/material";
import { useCallback, useMemo, useRef, useState } from "react";
import { useElementSize } from "../../../../hooks/index.js";
import { useToolbarGroups } from "./useToolbarGroups.js";
function DividerPlaceholder() {
  return null;
}
function useEditorToolbar(ref) {
  const rAnchor = useRef();
  const rootRef = useForkRef(ref, rAnchor);
  const { width: rootWidth } = useElementSize(rAnchor.current);
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  const [hidden, setHidden] = useState(0);
  const toolbarGroups = useToolbarGroups();
  const tools = useMemo(() => {
    const allTools = [];
    const lastIdx = toolbarGroups.length - 1;
    toolbarGroups.forEach(({ worms: tools2 }, idx) => {
      if (tools2.length === 0) return;
      allTools.push(...tools2);
      if (idx !== lastIdx) {
        allTools.push(/* @__PURE__ */ jsx(DividerPlaceholder, {}));
      }
    });
    return allTools;
  }, [toolbarGroups]);
  const overflowTools = useMemo(() => {
    const next = hidden > 0 ? tools.slice(-hidden) : [];
    return next;
  }, [tools, hidden]);
  const overflowOpen = hidden > 0 ? open : false;
  return {
    open: overflowOpen,
    tools,
    onOpen,
    onClose,
    rAnchor,
    rootRef,
    rootWidth,
    setHidden,
    overflowTools
  };
}
export {
  DividerPlaceholder,
  useEditorToolbar
};
//# sourceMappingURL=useEditorToolbar.js.map
